'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useEffect, useRef, useCallback } from 'react';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { useIsPopNavigation } from 'commons/navState';
import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import useFilterTransitionState from '../../hooks/useFilterTransitionState';
import AdvancedSearchProductsGrid from '../AdvancedSearchProductsGrid';
import LoadMoreButton from '../AdvancedSearchProductsGrid/LoadMoreButton';
import useHitsAccumulation from './hooks/useHitsAccumulation';
import useDisplayProducts from './hooks/useDisplayProducts';
import useScrollPersistence from './hooks/useScrollPersistence';
const AdvancedSearchProductHits = t0 => {
  const $ = _c(67);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onProductsChange
  } = t1;
  const {
    items,
    isLastPage,
    showMore
  } = useHitsAccumulation();
  const {
    results,
    status,
    setIndexUiState,
    indexUiState
  } = useInstantSearch();
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const mobileColumnCount = useMobileColumnCount();
  const {
    isReadyToShipActive,
    minWidth,
    maxWidth,
    activeTypeFilter,
    pagesUrlParam,
    updateUrlParamImmediate,
    selectedFacets
  } = useAdvancedSearchContext();
  const isPopNavigation = useIsPopNavigation();
  let t2;
  if ($[2] !== isPopNavigation) {
    t2 = isPopNavigation();
    $[2] = isPopNavigation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isPopRef = useRef(t2);
  const scrollRestoredRef = useRef(false);
  const targetPagesRef = useRef(pagesUrlParam);
  let t3;
  let t4;
  if ($[4] !== activeTypeFilter || $[5] !== setIndexUiState) {
    t3 = () => {
      setIndexUiState(prev => {
        const currentType = prev?.refinementList?.type?.[0] ?? null;
        if (currentType === activeTypeFilter) {
          return prev;
        }
        const newRefinementList = {
          ...(prev.refinementList || {})
        };
        if (activeTypeFilter) {
          newRefinementList.type = [activeTypeFilter];
        } else {
          delete newRefinementList.type;
        }
        return {
          ...prev,
          refinementList: newRefinementList
        };
      });
    };
    t4 = [activeTypeFilter, setIndexUiState];
    $[4] = activeTypeFilter;
    $[5] = setIndexUiState;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  const currentPageCount = Math.ceil((items?.length || 0) / NUMBER_OF_PRODUCTS_TO_SHOW);
  let t5;
  if ($[8] !== currentPageCount || $[9] !== isLastPage || $[10] !== items?.length || $[11] !== showMore || $[12] !== status) {
    t5 = () => {
      if (status !== "idle" || !items?.length || isLastPage) {
        return;
      }
      if (currentPageCount - 1 < targetPagesRef.current) {
        showMore();
      }
    };
    $[8] = currentPageCount;
    $[9] = isLastPage;
    $[10] = items?.length;
    $[11] = showMore;
    $[12] = status;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = items?.length;
  let t7;
  if ($[14] !== currentPageCount || $[15] !== isLastPage || $[16] !== showMore || $[17] !== status || $[18] !== t6) {
    t7 = [currentPageCount, status, t6, isLastPage, showMore];
    $[14] = currentPageCount;
    $[15] = isLastPage;
    $[16] = showMore;
    $[17] = status;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  useEffect(t5, t7);
  indexUiState?.refinementList;
  let t8;
  if ($[20] !== indexUiState?.refinementList || $[21] !== isReadyToShipActive || $[22] !== maxWidth || $[23] !== minWidth || $[24] !== selectedFacets) {
    t8 = JSON.stringify({
      refinementList: indexUiState?.refinementList || {},
      isReadyToShipActive,
      minWidth,
      maxWidth,
      selectedFacets: selectedFacets ? Object.fromEntries(Object.entries(selectedFacets).map(_temp)) : undefined
    });
    $[20] = indexUiState?.refinementList;
    $[21] = isReadyToShipActive;
    $[22] = maxWidth;
    $[23] = minWidth;
    $[24] = selectedFacets;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const filterStateKey = t8;
  let t9;
  if ($[26] !== activeTypeFilter || $[27] !== filterStateKey || $[28] !== items || $[29] !== setIndexUiState || $[30] !== status || $[31] !== updateUrlParamImmediate) {
    t9 = {
      filterStateKey,
      setIndexUiState,
      items,
      status,
      activeTypeFilter,
      updateUrlParamImmediate,
      isPopRef,
      scrollRestoredRef,
      targetPagesRef
    };
    $[26] = activeTypeFilter;
    $[27] = filterStateKey;
    $[28] = items;
    $[29] = setIndexUiState;
    $[30] = status;
    $[31] = updateUrlParamImmediate;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const {
    isFilterTransitioning,
    hasSearchCompleted,
    showNoResults
  } = useFilterTransitionState(t9);
  let t10;
  if ($[33] !== items || $[34] !== results || $[35] !== searchBoxQuery) {
    t10 = {
      items,
      searchBoxQuery,
      results
    };
    $[33] = items;
    $[34] = results;
    $[35] = searchBoxQuery;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  const {
    displayProducts,
    loading,
    productIds,
    productIdsRaw
  } = useDisplayProducts(t10);
  const t11 = items?.length;
  let t12;
  if ($[37] !== currentPageCount || $[38] !== loading || $[39] !== productIds.length || $[40] !== productIdsRaw.length || $[41] !== status || $[42] !== t11) {
    t12 = {
      isPopRef,
      scrollRestoredRef,
      targetPagesRef,
      status,
      currentPageCount,
      itemsLength: t11,
      loading,
      productIdsLength: productIds.length,
      productIdsRawLength: productIdsRaw.length
    };
    $[37] = currentPageCount;
    $[38] = loading;
    $[39] = productIds.length;
    $[40] = productIdsRaw.length;
    $[41] = status;
    $[42] = t11;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  useScrollPersistence(t12);
  let t13;
  let t14;
  if ($[44] !== displayProducts || $[45] !== onProductsChange) {
    t13 = () => {
      if (onProductsChange && displayProducts?.length > 0) {
        onProductsChange(displayProducts);
      }
    };
    t14 = [displayProducts, onProductsChange];
    $[44] = displayProducts;
    $[45] = onProductsChange;
    $[46] = t13;
    $[47] = t14;
  } else {
    t13 = $[46];
    t14 = $[47];
  }
  useEffect(t13, t14);
  let t15;
  if ($[48] !== pagesUrlParam || $[49] !== showMore || $[50] !== updateUrlParamImmediate) {
    t15 = () => {
      const nextPages = pagesUrlParam + 1;
      showMore();
      targetPagesRef.current = nextPages;
      updateUrlParamImmediate?.({
        pages: nextPages
      });
    };
    $[48] = pagesUrlParam;
    $[49] = showMore;
    $[50] = updateUrlParamImmediate;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  const handleShowMore = t15;
  const isRefreshing = status === "loading" || status === "stalled" || loading;
  if (!items?.length) {
    const showSkeleton = status === "loading" || status === "stalled" || isFilterTransitioning || !hasSearchCompleted || !showNoResults;
    if (showSkeleton) {
      let t16;
      if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <ProductCardStaticPlaceholderGroup count={NUMBER_OF_PRODUCTS_TO_SHOW} />;
        $[52] = t16;
      } else {
        t16 = $[52];
      }
      let t17;
      if ($[53] !== mobileColumnCount) {
        t17 = <div className="md:space-y-8 md:mb-8 md:flex-1 min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t16}</ProductCardGridUI></div>;
        $[53] = mobileColumnCount;
        $[54] = t17;
      } else {
        t17 = $[54];
      }
      return t17;
    }
    let t16;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
      $[55] = t16;
    } else {
      t16 = $[55];
    }
    return t16;
  }
  const t16 = isRefreshing ? "animate-pulse" : "";
  let t17;
  if ($[56] !== displayProducts) {
    t17 = displayProducts?.length > 0 && <AdvancedSearchProductsGrid products={displayProducts} />;
    $[56] = displayProducts;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  let t18;
  if ($[58] !== displayProducts?.length || $[59] !== handleShowMore || $[60] !== isLastPage || $[61] !== loading) {
    t18 = displayProducts?.length > 0 && !isLastPage && <div className="flex justify-center mt-8 mb-12"><LoadMoreButton onClick={handleShowMore} isLoading={loading} /></div>;
    $[58] = displayProducts?.length;
    $[59] = handleShowMore;
    $[60] = isLastPage;
    $[61] = loading;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== t16 || $[64] !== t17 || $[65] !== t18) {
    t19 = <div className={t16}>{t17}{t18}</div>;
    $[63] = t16;
    $[64] = t17;
    $[65] = t18;
    $[66] = t19;
  } else {
    t19 = $[66];
  }
  return t19;
};
export default AdvancedSearchProductHits;
function _temp(t0) {
  const [attr, values] = t0;
  return [attr, [...values].sort()];
}